import { useSelector } from "react-redux";
import { FinanceableLogo, Stack, Typography } from "@financeable-com-au/financeable-ui";
import { themeSelector } from "@/store/slices/themeSlice";

const BrandLogo = () => {
  const { theme } = useSelector(themeSelector);

  if (theme?.tenancyLogo) {
    return (
      <Stack
        bgcolor={theme.primary[400]}
        padding={4}
        borderRadius="lg"
        width="120px"
        height="120px"
        alignItems="center"
        justifyContent="center"
      >
        <img src={theme.tenancyLogo} alt="Logo" width="100%" height="auto" />
      </Stack>
    );
  }

  return (
    <Stack bgcolor="neutral.900" padding={4} borderRadius="lg" alignItems="center" justifyContent="center">
      <FinanceableLogo variant="light" width="180px" />
    </Stack>
  );
};

export { BrandLogo };
